/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPWITHHOLDINGTAXTYPE = {
    Dividend: 'D',
    Interest: 'I'
} as const;
export type IAPWITHHOLDINGTAXTYPE = typeof IAPWITHHOLDINGTAXTYPE[keyof typeof IAPWITHHOLDINGTAXTYPE];


export function IAPWITHHOLDINGTAXTYPEFromJSON(json: any): IAPWITHHOLDINGTAXTYPE {
    return IAPWITHHOLDINGTAXTYPEFromJSONTyped(json, false);
}

export function IAPWITHHOLDINGTAXTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPWITHHOLDINGTAXTYPE {
    return json as IAPWITHHOLDINGTAXTYPE;
}

export function IAPWITHHOLDINGTAXTYPEToJSON(value?: IAPWITHHOLDINGTAXTYPE | null): any {
    return value as any;
}

